exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "social-security{display:block}social-security .container-data{padding:10px;padding-top:5px;background-color:#f9f9f9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/social-security.module/features/socialSecurity/socialSecurity.scss
// module id = 2326
// module chunks = 0